<template>
	<div>
		<nuxt-link v-for="(v) in $options.menuVehicles.filter(v => v.id !== 'vehiclesIndex')" :key="v.id" :to="v.href"
			@click.native="goToTop(v.href)"
			class="group shadow-sm hover:shadow rounded-6">
			<article class=" flex flex-col h-full border border-goGrayBrighter rounded-6 overflow-hidden">
				<figure>
					<img :src="$cloudFlare.getImage(v.image.tablet.src)" width="296" height="148" loading="lazy" decoding="async" :alt="v.image.alt" class="bg-gray-50 object-cover w-full h-full"/>
				</figure>
				<div class="p-8 desktop:px-16 flex flex-col  ">
					<p class="text-16 font-bold whitespace-nowrap truncate">{{ v.text }}</p>
					<p class=" text-14 link link-goBlue font-bold">+ info</p>
				</div>
			</article>
		</nuxt-link>
	</div>
</template>

<script>
import { menuVehicles } from '~/static/data/menuVehicles';

export default {
	menuVehicles,
	methods: {
		goToTop(href) {
			if (this.$route.fullPath.includes(href)){
				this.$scrollTo()
			}
		}
	}
};
</script>
